import { cn } from '@/utils/cn';

const variants = {
  primary:
    'bg-[var(--primary)] text-[var(--primary-foreground)] hover:opacity-90 shadow-[var(--shadow-sm)]',
  secondary:
    'bg-[var(--secondary)] text-[var(--secondary-foreground)] hover:opacity-90',
  outline:
    'border border-[var(--border)] bg-transparent hover:bg-[var(--muted)]',
  ghost: 'bg-transparent hover:bg-[var(--muted)]',
  destructive:
    'bg-[var(--destructive)] text-[var(--destructive-foreground)] hover:opacity-90',
};

const sizes = {
  sm: 'h-9 px-3 text-sm',
  md: 'h-10 px-4 text-sm',
  lg: 'h-11 px-5 text-base',
  icon: 'h-10 w-10',
  'icon-sm': 'h-8 w-8',
};

export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  type = 'button',
  disabled,
  loading,
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={cn(
        'inline-flex cursor-pointer items-center justify-center gap-2 rounded-[var(--radius)] font-medium transition disabled:cursor-not-allowed disabled:opacity-60',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    >
      {loading ? 'Carregando...' : children}
    </button>
  );
}
